// components/shared/Breadcrumb/CommonBreadcrumb.js
import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CommonBreadcrumb = ({ items = [] }) => {
  return (
    <Breadcrumb className="mb-3">
      {items.map((item, index) => (
        <Breadcrumb.Item
          key={index}
          linkAs={item.path ? Link : 'span'}
          linkProps={item.path ? { to: item.path } : {}}
          active={index === items.length - 1}
        >
          {item.label}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default CommonBreadcrumb;
